<template>
  <div>
    <h1>Edit Mover</h1>
    <div class="row mb-3">
      <div class="col">
        <button class="btn btn-danger pull-right"
                v-if="mover.status_id === 2"
                @click="changeStatus(3)"
        >
          Deactivate mover
        </button>
        <button class="btn btn-success pull-right"
                v-else
                @click="changeStatus(2)"
        >
          Activate mover
        </button>
      </div>
    </div>
    <div>
      <div v-if="mover" class="l-bg-white">
        <mover-edit-info :mover="mover" @updated="loadMover" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../../classes/Errors';
import MoverEditInfo from './MoversEditInfo';
import PhoneMask from '../../classes/PhoneMask';

export default {
  name: 'MoverEdit',
  components: {
    MoverEditInfo,
  },
  data: () => ({
    mover: {
      email: '',
      first_name: '',
      last_name: '',
      phone: 0,
      password: '',
      password_confirmation: '',
      user_status_id: 0,
      username: '',
      date_of_birth: '',
      address: {
        full_address: '',
        street_name: '',
        state: [
          {
            name: '',
          },
        ],
        state_id: 0,
        city: '',
        postal_code: '',
        apartment: '',
      },
      address2: '',
      city: '',
      state: [
        {
          id: '',
        },
      ],
      state_id: 0,
      zip: '',
      description: '',
      status_id: 0,
      ssn: '',
      ssn_verified: false,
      foreman: false,
      showDropdown: false,
      carrier_id: 0,
    },
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      step: state => state.movers.step,
    }),
  },
  destroyed() {
    this.setMoversStep('movers-info');
  },
  mounted() {
    this.loadMover();
  },
  methods: {
    ...mapMutations(['setMoversStep']),
    changeStatus(statusId) {
      const moverId = this.$route.params.id;
      axios
        .patch(`movers/${moverId}`, { status_id: statusId })
        .then(res => {
          this.mover = res.data.data;
          this.mover.zip = res.data.data.zip.zip;
          toastr.success('Successfully Changed Status');
          this.$forceUpdate();
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    loadMover() {
      const moverId = this.$route.params.id;
      axios
        .get(`movers/${moverId}`)
        .then(res => {
          this.mover = res.data.data;
          this.mover.phone = this.phoneMask.maskedPhone(this.mover.phone);
          this.mover.zip = res.data.data.zip ? res.data.data.zip.zip : null;
          this.mover.state_id = this.mover.state ? this.mover.state.id : null;
          this.mover.carrier_id = res.data.data.carrier_id;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    maskPhone(event) {
      this.$nextTick(() => {
        this.$set(this.mover, 'phone', this.phoneMask.maskedPhone(this.mover.phone));
        this.clearError(event);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/movers/MoversEdit.vue